import React from 'react'
import { IbRegistrationtepsContextProvider } from '../../context/ibRegistrationContext'
import { IbRegistrationStepRoutes } from '../../routes/ibRegistration/ibRegistration'

export default function IbRegistrationWithStepsContext() {
  return (
    <IbRegistrationtepsContextProvider>
      <IbRegistrationStepRoutes />
    </IbRegistrationtepsContextProvider>
  )
}
